import IconView from "../IconView";
import DragModal from "../../../modals/DragModal";


let SettingsIconView = IconView.createPlugin("settings", {

    initialize() {
        SettingsIconView.__super__.initialize.apply(this, arguments);

        this.modal = new DragModal({
            title: this.model.get("title")
        });
    },

    onOpen() {
        this.modal.show();
    }
});

export default SettingsIconView;
